<section class="relative mb:pb-24 pb-16 -mt-16 z-1">
  <div class="container">
      <div class="grid grid-cols-1">
          <div class="md:flex justify-between items-center shadow dark:shadow-gray-700 rounded-md p-6 bg-white dark:bg-slate-900">
              <div class="flex items-center">
                  <img [src]="vestiging.foto" class="object-cover h-20 w-20 p-3 shadow dark:shadow-gray-700 rounded-md bg-slate-50 dark:bg-slate-800" alt="">

                  <div class="ltr:ml-4 rtl:mr-4">
                      <h5 class="text-xl font-bold">{{vestiging.naam}}</h5>
                      <h6 class="text-base text-slate-400"><i class="uil uil-map-marker"></i> {{vestiging.naam}}, België</h6>
                  </div>
              </div>

              <div class="md:mt-0 mt-4">
                  <!--<a href="" class="btn btn-sm bg-emerald-600 hover:bg-emerald-700 border-emerald-600 dark:border-emerald-600 text-white rounded-md">Follow</a>-->
                  <a [routerLink]="['/vacatures']" routerLinkActive="router-link-active"  class="btn btn-sm bg-earth-try hover:bg-earth-dark border-earth-common hover:border-black/70 text-black/70 hover:text-black/70 rounded-md ltr:ml-1 rtl:mr-1">Bekijk vacatures</a>
              </div>
          </div>
      </div><!--end grid-->
  </div><!--end container-->

  <div class="container mt-12">
      <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
          <div class="lg:col-span-8 md:col-span-7">
              <h5 class="text-xl font-semibold">Over de praktijk</h5>
              <p class="text-slate-400 mt-4">{{ vestiging.beschrijving }}</p>

              <h5 class="text-xl font-semibold mt-8">Team {{vestiging.naam}}</h5>

              <div class="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] mt-4">
                <app-member-card *ngFor="let member of members" [member]="member" [details]="false"></app-member-card>
              </div>

              <h5 class="text-xl font-semibold mt-8">Specialisaties</h5>

              <div class="grid lg:grid-cols-2 grid-cols-1 gap-6 mt-4">
                  <app-specialisatie-card *ngFor="let spec of specs" [spec]="spec"></app-specialisatie-card>
              </div>

              <div class="grid grid-cols-12 gap-6 mt-12" *ngIf="vestiging.detailfotos">
                  <div class="col-span-12">
                      <img [src]="vestiging.detailfotos[0]" class="rounded-md shadow dark:shadow-gray-700" alt="">
                  </div>
                  <div class="col-span-6">
                      <img [src]="vestiging.detailfotos[1]" class="rounded-md shadow dark:shadow-gray-700" alt="">
                  </div>
                  <div class="col-span-6">
                      <img [src]="vestiging.detailfotos[2]" class="rounded-md shadow dark:shadow-gray-700" alt="">
                  </div>
              </div>
          </div>

          <div class="lg:col-span-4 md:col-span-5">
              <div class="bg-slate-50 dark:bg-slate-800 rounded-md shadow dark:shadow-gray-700 p-6 sticky top-20">
                  <div class="w-full leading-[0] border-0">
                      <iframe [src]="'https://www.google.com/maps/embed?'+vestiging.maps_link | safe:'url'" style="border:0" class="w-full h-[350px] rounded-md shadow dark:shadow-gray-700" allowfullscreen></iframe>
                  </div>

                  <ul class="list-none mt-4">
                      <li class="flex justify-between mt-2">
                          <span class="text-slate-400 font-medium">Straat:</span>
                          <span class="font-medium">{{vestiging.straat + ' ' + vestiging.huisnummer}}</span>
                      </li>

                      <li class="flex justify-between mt-2">
                          <span class="text-slate-400 font-medium">Gemeente:</span>
                          <span class="font-medium">{{vestiging.gemeente}}</span>
                      </li>

                      <li class="flex justify-between mt-2">
                          <span class="text-slate-400 font-medium">E-mail:</span>
                          <span class="font-medium">{{vestiging.naam?.toLowerCase()}}@mudico.be</span>
                      </li>

                      <li class="flex justify-between mt-2">
                          <span class="text-slate-400 font-medium">Kanalen:</span>

                          <ul class="list-none ltr:text-right rtl:text-left">
                              <li class="inline"><a href="https://www.facebook.com/mudico1" target="_blank"  class="btn btn-icon btn-sm text-black/70 border-2 border-earth-try bg-earth-try rounded-md hover:border-earth-dark hover:bg-earth-dark"><i class="uil uil-facebook-f" title="facebook"></i></a></li>
                              <li class="inline"><a href="https://www.instagram.com/groepspraktijk_mudico/" target="_blank" class="btn btn-icon btn-sm text-black/70 border-2 border-earth-try bg-earth-try rounded-md hover:border-earth-dark hover:bg-earth-dark ml-1"><i class="uil uil-instagram align-middle" title="instagram"></i></a></li>
                              <li class="inline"><a [href]="'mailto:'+vestiging.naam?.toLowerCase()+'@mudico.be'" class="btn btn-icon btn-sm text-black/70 border-2 border-earth-try bg-earth-try rounded-md hover:border-earth-dark hover:bg-earth-dark ml-1"><i class="uil uil-envelope align-middle" title="email"></i></a></li>
                          </ul><!--end icon-->
                      </li>
                  </ul>

                  <div class="mt-4 pt-2 border-t dark:border-t-gray-700 text-center">
                      <h5 class="text-lg font-semibold">Contacteer ons!</h5>

                      <button class="btn bg-earth-try hover:bg-earth-dark border-earth-common hover:border-black/70 text-black/70 hover:text-black/70 rounded-md mt-4" [routerLink]="['/contact']" routerLinkActive="router-link-active" >Stel je vraag</button>
                  </div>
              </div>
          </div><!--end col-->
      </div><!--end grid-->
  </div><!--end container-->


</section><!--end section-->
